import React, { useState } from 'react';
import { sendEmail } from '../utils/emailService';
import { showSuccessAlert } from '../utils/alertService';

function BpoServicesHero() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    await sendEmail({
      form_type: 'BPO Services Consultation Inquiry',
      name: formData.name,
      from_name: formData.name,
      user_name: formData.name,
      email: formData.email,
      from_email: formData.email,
      user_email: formData.email,
      phone: formData.phone,
      user_phone: formData.phone,
      company: formData.company,
      service: 'BPO & Call Center Services',
      service_interested: 'BPO Services',
      message: `Consultation Request:
Name: ${formData.name}
Email: ${formData.email}
Phone: ${formData.phone}
Company: ${formData.company}
Message: ${formData.message}`
    });

    setLoading(false);
    setIsSubmitted(true);
    showSuccessAlert(
      'Request Received!',
      `Thank you, ${formData.name || 'valued client'}! Your BPO consultation request has been sent successfully.`
    );
    setFormData({
      name: '',
      email: '',
      phone: '',
      company: '',
      message: ''
    });
    setTimeout(() => {
      setIsSubmitted(false);
    }, 5000);
  };

  const scrollToForm = () => {
    const formEl = document.getElementById('bpo-hero-form');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="bpo-hero-section">
      {/* Subtle tech background network glow */}
      <div className="bpo-hero-bg-overlay"></div>
      
      <div className="container bpo-hero-container">
        <div className="bpo-hero-grid">
          {/* Left Column: Title, Description & CTA */}
          <div className="bpo-hero-left">
            <h1 className="bpo-hero-title">
              Advanced business process outsourcing services
            </h1>
            
            <p className="bpo-hero-desc">
              Our business process outsourcing service uses modern technology and proven 
              methodologies to optimize your customer interactions and drive measurable results. 
              Book free consultation and lets discuss your needs.
            </p>

            <button className="btn-bpo-consultation" onClick={scrollToForm}>
              Book Free Consultation Now
            </button>
          </div>

          {/* Right Column: Form with Red Accent Bar Header */}
          <div className="bpo-hero-right" id="bpo-hero-form">
            <div className="bpo-form-header">
              <div className="bpo-header-red-bar"></div>
              <div className="bpo-header-text">
                <h2 className="bpo-form-title">Streamline your BPO Operations.</h2>
                <h3 className="bpo-form-subtitle">Get free consultation</h3>
              </div>
            </div>

            {isSubmitted ? (
              <div className="bpo-form-success">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#c40a0a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                  <polyline points="22 4 12 14.01 9 11.01" />
                </svg>
                <h4>Thank you for reaching out!</h4>
                <p>Our BPO consultation specialist will connect with you shortly.</p>
              </div>
            ) : (
              <form className="bpo-hero-form" onSubmit={handleSubmit}>
                <div className="bpo-form-row">
                  <div className="bpo-input-group">
                    <input 
                      type="text" 
                      name="name" 
                      placeholder="Your name" 
                      value={formData.name}
                      onChange={handleChange}
                      required 
                    />
                  </div>
                  <div className="bpo-input-group">
                    <input 
                      type="email" 
                      name="email" 
                      placeholder="Email" 
                      value={formData.email}
                      onChange={handleChange}
                      required 
                    />
                  </div>
                </div>

                <div className="bpo-form-row">
                  <div className="bpo-input-group">
                    <input 
                      type="tel" 
                      name="phone" 
                      placeholder="Phone number" 
                      value={formData.phone}
                      onChange={handleChange}
                      required 
                    />
                  </div>
                  <div className="bpo-input-group">
                    <input 
                      type="text" 
                      name="company" 
                      placeholder="Company name" 
                      value={formData.company}
                      onChange={handleChange} 
                    />
                  </div>
                </div>

                <div className="bpo-input-group full-width">
                  <textarea 
                    name="message" 
                    placeholder="Message" 
                    rows="4"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>

                <div className="bpo-submit-wrapper">
                  <button type="submit" className="btn-bpo-submit" disabled={loading}>
                    {loading ? 'Submitting...' : 'Submit'}
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default BpoServicesHero;
